import { ValidHeimspielStartingListProps } from './types'

const isValidHeimspielStartingListProps = (
  props: any,
): props is ValidHeimspielStartingListProps => !!props?.matchId

export { isValidHeimspielStartingListProps }
